import { createStore } from 'vuex';

import auth from '@/modules/auth/auth.store.js';
import events from '@/modules/events/events.store.js';
import wishlist from '@/modules/wishlist/wishlist.store.js';

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    events,
    wishlist,
  },
});
